import { createContext } from "react";

import React from 'react'
import { useState } from "react";
export const BlogContext =createContext()


 function BlogProvider (props) {
const [post,setPost] =useState()
const [isloggedIn,setIsLoggedIn]=useState(false)
   
  return (
    <BlogContext.Provider value={{post,isloggedIn}}>
{props.children}
    
    </BlogContext.Provider>
  )
}
export default BlogProvider